<template>
  <div class="ExamContentListModal">
    <el-dialog
      title="试卷排序"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @open="handleOpen"
    >
      <div class="table">
        <XTable
          :api="getProductSubjectContentList"
          :state="subjectContentList"
          :columns="columns"
          :loading="subjectContentListLoading"
          :tableSize="tableSize"
          :layout="layout"
          :maxHeight="maxHeight"
          :firstColumn="firstColumn"
          :editRowId="editRowId"
        ></XTable>
      </div>
      <div class="footer">
        <el-button
          v-if="subjectContentListFilter.type"
          size="small"
          style="width: 120px"
          type="primary"
          @click="handleConfirm"
          >确认
        </el-button>
        <el-button
          v-else
          size="small"
          style="width: 120px"
          type="primary"
          @click="handleClose"
          >关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "ExamContentListModal",
  components: { XTable },
  data() {
    const self = this;
    const columns = [
      {
        prop: "lessonName",
        minWidth: 140,
        label: "试卷名称",
      },
      // {
      //   prop: "classSubjectName",
      //   minWidth: 140,
      //   label: "分组",
      // },
    ];
    return {
      timer: null,
      editRowId: null,
      tableSize: "small",
      layout: "",
      maxHeight: 500,
      firstColumn: true,
      columns: [
        ...columns,
        {
          label: "操作",
          fixed: "right",
          minWidth: 220,
          render(h, scope) {
            return (
              <div>
                <el-button
                  onClick={() => {
                    self.handleUp(scope);
                  }}
                  disabled={scope.$index === 0}
                  size="mini"
                  type="primary"
                  plain
                >
                  上移
                </el-button>
                <el-button
                  onClick={() => {
                    self.handleDown(scope);
                  }}
                  disabled={scope.store.states.data.length === scope.$index + 1}
                  size="mini"
                  type="primary"
                  plain
                >
                  下移
                </el-button>
                <el-button
                  onClick={() => {
                    self.handleRemove(scope);
                  }}
                  size="mini"
                  type="primary"
                  plain
                >
                  移出
                </el-button>
              </div>
            );
          },
        },
      ],
    };
  },
  computed: {
    ...mapState("teachingCenter", [
      "subjectContentListLoading",
      "subjectContentList",
      "subjectContentListFilter",
    ]),
    visible: {
      get() {
        return this.$store.state.teachingCenter.examContentListModalVisible;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "examContentListModalVisible",
          value,
        });
      },
    },
  },
  beforeDestroy() {
    // 在组件销毁前，清除定时器
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.setData({ key: "examContentListModalVisible", value: false });
  },
  methods: {
    ...mapActions("teachingCenter", [
      "getProductSubjectContentList",
      "saveCustomSubjectMirror",
    ]),
    ...mapMutations("teachingCenter", ["setData"]),
    async handleOpen() {
      (this.editRowId = null), await this.getProductSubjectContentList();
    },
    // 向上移动
    handleUp(scope) {
      this.editRowId = scope.row.lessonId;
      this.setData({ key: "subjectContentListLoading", value: true });
      this.timer = setTimeout(() => {
        const temp = this.subjectContentList.data[scope.$index];
        this.subjectContentList.data.splice(scope.$index, 1);
        this.subjectContentList.data.splice(scope.$index - 1, 0, temp);
        this.setData({ key: "subjectContentListLoading", value: false });
      }, 200);
    },
    // 向下移动
    handleDown(scope) {
      this.editRowId = scope.row.lessonId;
      this.setData({ key: "subjectContentListLoading", value: true });
      this.timer = setTimeout(() => {
        const temp = this.subjectContentList.data[scope.$index];
        this.subjectContentList.data.splice(scope.$index, 1);
        this.subjectContentList.data.splice(scope.$index + 1, 0, temp);
        this.setData({ key: "subjectContentListLoading", value: false });
      }, 200);
    },
    //   移出
    handleRemove(scope) {
      this.subjectContentList.data.splice(scope.$index, 1);
    },
    async handleConfirm() {
      //   将this.subjectContentList.data中的lessonId按顺序取出来
      let lessonIdList = this.subjectContentList.data.map(
        (item) => item.lessonId
      );
      const res = await this.saveCustomSubjectMirror({
        id: this.subjectContentListFilter.id,
        lessonIdList: lessonIdList,
        mirrorNo: this.subjectContentListFilter.mirrorNo,
        type: this.subjectContentListFilter.type,
      });
      this.$message.success("操作成功");
      lessonIdList = null;
      this.$emit("handleSortSuccess", res.data);
      this.setData({ key: "examContentListModalVisible", value: false });
    },
    handleClose() {
      this.setData({ key: "examContentListModalVisible", value: false });
    },
  },
};
</script>

<style lang="scss" scoped>
.ExamContentListModal {
  ::v-deep .el-dialog {
    min-width: 800px !important;
    min-height: 600px !important;
  }

  ::v-deep .el-dialog .el-dialog__body {
    padding: 20px 20px;
  }

  ::v-deep .el-pagination {
    text-align: right;
  }

  .table {
    height: 500px;
  }

  .footer {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
